import React, { useState, useEffect, useContext } from "react";
import { Box, TablePagination, useMediaQuery } from "@mui/material";
import Header from "../../Components/Common/Header";
import experienceBanner from "../../Assets/Images/experienceBanner.png";
import SearchBar from "../../Components/Common/SearchBar";
import Container from "../../Components/Layout/Container";
import Card from "../../Components/Common/Card";
import FilterModal from "../../Components/Expereince/FiltreModal";
import Navbar from "../../Components/Common/Navbar";
import Footer from "../../Components/Common/Footer";
import { useTheme } from "@emotion/react";
import axios from "axios";
import { BASE_URL } from "../../Assets/Constants";
import { toast } from "react-toastify";
import { CurrencyContext } from "../../Services/CurrencyContext";
import { useLocation } from "react-router-dom";

function Experience() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(12);
  const [open, setOpen] = useState(false);
  const [experiencesData, setExperiencesData] = useState([]);
  const [filteredDatas, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchQueryInner, setSearchQueryInner] = useState("");

  const [loading, setLoading] = useState(true);

  const themes = useTheme();
  const { currency, setCurrency } = useContext(CurrencyContext);
  const isSmallScreen = useMediaQuery(themes.breakpoints.down("sm"));
  const location = useLocation();
  const countryData = location?.state?.data;

  useEffect(() => {
    if (experiencesData?.currency && experiencesData?.currency !== currency) {
      setCurrency(experiencesData.currency);
    }
  }, [experiencesData, currency, setCurrency]);

  const fetchExperiences = async (selectedCurrency) => {
    setLoading(true);
    try {
      const loginData = JSON.parse(localStorage.getItem("loginData"));
      const token = loginData?.token;
      const response = await axios.post(
        `${BASE_URL}/user/experiences`,
        { currencysymbol: selectedCurrency },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (Array.isArray(response.data?.data)) {
        setExperiencesData(response.data.data);
        setFilteredData(response.data?.data || []);
      } else {
        console.error("Unexpected data format: `data` is not an array");
        setExperiencesData([]);
      }
    } catch (error) {
      toast.error(error?.response?.data?.error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      console.error("Error fetching experiences:", error?.response);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchExperiences(currency);
  }, [currency]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const filteredData = filteredDatas.filter((item) =>
    item?.name?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const filteredDataInner = filteredDatas.filter((item) =>
    item?.name?.toLowerCase().includes(searchQueryInner.toLowerCase())
  );

  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const paginatedDataInner = filteredDataInner.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const displayedData = countryData?.length
    ? countryData
        .filter((item) =>
          item.name?.toLowerCase().includes(searchQuery.toLowerCase())
        )
        .filter((item) =>
          item.name?.toLowerCase().includes(searchQueryInner.toLowerCase())
        )
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    : searchQueryInner && paginatedDataInner.length > 0
    ? paginatedDataInner
    : paginatedData.length > 0
    ? paginatedData
    : [];

  const totalCount = countryData?.length
    ? countryData.filter(
        (item) =>
          item.name?.toLowerCase().includes(searchQuery.toLowerCase()) &&
          item.name?.toLowerCase().includes(searchQueryInner.toLowerCase())
      ).length
    : searchQueryInner
    ? filteredDataInner.length
    : filteredData.length;

  if (loading) {
    return (
      <>
        <style>{loaderStyle.spinnerAnimation}</style>
        <div style={loaderStyle.loaderContainer}>
          <div style={loaderStyle.spinner}></div>
        </div>
      </>
    );
  }

  const handleApplyFilters = (filteredResults) => {
    setFilteredData(filteredResults);
  };

  const handleClearFilters = () => {
    setFilteredData(experiencesData);
  };

  return (
    <>
      <Navbar
        currency={currency}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />
      <Box>
        <Header
          banner={experienceBanner}
          label1={"Find The Experience that you like"}
          width="60%"
        />
        <FilterModal
          onApplyFilters={handleApplyFilters}
          onClearFilters={handleClearFilters}
          data={experiencesData}
          open={open}
          setOpen={setOpen}
        />
        <Box my={5}>
          <SearchBar
            searchQuery={searchQueryInner}
            setSearchQuery={setSearchQueryInner}
            filterClick={() => setOpen(true)}
            width={isSmallScreen ? "230px" : "508px"}
            height="60px"
          />
        </Box>
        <Container>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "repeat(1, 1fr)",
                sm: "repeat(2, 1fr)",
                md: "repeat(6, 1fr)",
              },
              gap: 3,
              "@media (min-width: 900px) and (max-width: 1300px)": {
                gridTemplateColumns: "repeat(3, 1fr)",
              },
              "@media (min-width: 1280px) and (max-width: 1366px)": {
                gridTemplateColumns: "repeat(6, 1fr)",
              },
            }}
          >
            {searchQueryInner && filteredDataInner.length === 0 ? (
              <Box textAlign="center" mt={2}>
                No matching data found for "{searchQueryInner}"
              </Box>
            ) : displayedData.length > 0 ? (
              displayedData.map((value, index) => (
                <Card key={index} data={value} />
              ))
            ) : (
              <Box textAlign="center" mt={2}>
                No data available right now.
              </Box>
            )}
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: 5,
            }}
          >
            <TablePagination
              rowsPerPage={rowsPerPage}
              page={page}
              count={totalCount}
              component="div"
              onPageChange={handleChangePage}
              sx={{
                "& .MuiSelect-icon": {
                  display: "none",
                },
                "& .MuiTablePagination-toolbar": {
                  display: "flex",
                  justifyContent: "flex-end",
                },
                "& .MuiTablePagination-selectLabel, & .MuiTablePagination-select, & .css-1brww8i-MuiInputBase-root-MuiTablePagination-select":
                  {
                    display: "none",
                  },
                "& .MuiTablePagination-actions button:enabled": {
                  color: themes.colors.orange,
                },
              }}
            />
          </Box>
        </Container>
      </Box>
      <Footer />
    </>
  );
}

const loaderStyle = {
  loaderContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f9f9f9",
  },
  spinner: {
    width: "50px",
    height: "50px",
    border: "5px solid rgba(0, 0, 0, 0.1)",
    borderTop: "5px solid #FF7900",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
  spinnerAnimation: `
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  `,
};

export default Experience;
